/**
 * Mixin errorów
 *
 * @export
 * @param {*} prefix
 * @returns
 */
export function errorMixin(prefix) {
  return {
    data() {
      const sid = prefix + Math.round(Math.random() * 1000000);
      const errId = 'err_' + sid;
      return { sid, errId };
    }
  };
}
